<template>
  <div>
    <!--信息详情ID：{{msgId}}-->
    <div class="col-xs-10 col-sm-10 grid_div" id="grid_right_div">
      <!--<div id="flushBtn"></div>-->
      <div id="contentDiv">
        <div class="head_title">
          <div class="head_title_font">信息管理&gt;信息详情</div>
        </div>
        <div class="body_content">
          <button type="button" class="btn btn_back" @click="reBackMsgList()">
            返回
          </button>
          <h3 class="message_title">{{messageOne.title}}</h3>
          <button type="button" class="btn btn-default btn_close" v-if="messageOne.iftrace == 1" @click="closeTrack(messageOne.id)">关闭追踪</button>
          <div class="message_time">时间：{{messageOne.createTime}}</div>
          <div class="message_recName">收件人：{{messageOne.recName}}</div>
          <hr>
          <div class="message_content">{{messageOne.content}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {schoolAxios} from '../main';

  import {getContentSize} from './mainView';

  export default {
    name: "messageDetails",
    data() {
      return {
        msgId: this.$store.state.msgDetailsId,
        messageOne:{
          id:'',
          title:'',
          content:'',
          createTime:'',
          recName:'',
          iftrace: '',
        },
      }
    },
    filters: {

    },
    created: function () {

    },
    mounted: function () {
      let this_ = this;
      this.$nextTick(function () {
        getContentSize();

        this_.loadMessageDetails();
      })
    },
    methods: {
      /**
       * 加载信息详情
       */
      loadMessageDetails(){
        let this_=this;
        schoolAxios({
          method:'get',
          url: 'notice/loadNotice/'+this_.msgId,
          params:{}
        }).then(function (response) {
          let data = response.data;
          if(data.success){
            this_.messageOne.id=data.data.id;
            this_.messageOne.title=data.data.title;
            this_.messageOne.createTime=data.data.createTime;
            this_.messageOne.recName=data.data.recName;
            this_.messageOne.content=data.data.content;
            this_.messageOne.iftrace=data.data.iftrace;
          }
        })
      },
      /**
       * 关闭追踪
       */
      closeTrack(closeTrackId){
        let this_ = this;
        schoolAxios({
          method: 'put',
          url: 'notice/editIftrace',
          data: {
            id: closeTrackId,
            iftrace: 0
          }
        }).then(function (resp) {
          let data = resp.data;
          if(data.success){
            this_.loadMessageDetails();
          }
        });
      },
      /**
       * 返回信息列表
       */
      reBackMsgList(){
        let this_ = this;
        //路由跳转
        this_.$router.push({
          name: 'Message',
        });
      },
    }
  }
</script>

<style scoped>
  @import '../assets/css/plugins.css';
  @import "../assets/css/publicStyle.css";
  >>>.btn_back {
    width: 5%;
    margin: 30px 0 0 0;
  }
  .message_title {
    margin: 60px 0 0 0;
  }
  .btn_close {
    position: absolute;
    left: 15%;
    top: 15%;
    width: 8%;
  }

  .btn_back,.btn_close {
    background-color:#666666;
    color: #FFFFFF;
  }
  .btn_back:hover,.btn_close:hover {
    background-color:#2b2b2b;
  }
  .message_time {
    margin: 10px 0 0 0;
  }
  .message_recName {
    margin: 10px 0 0 0;
  }
  .message_content {
    margin: 20px 0 0 0;
  }

</style>



// WEBPACK FOOTER //
// src/components/messageDetails.vue